import Usercentrics from "../Usercentrics/usercentrics";

let map: google.maps.Map | undefined;

type LocationHitMapsApi = {
  /**
   * Set up Google Maps related event handlers for the Usercentrics
   * initialize and updated events.
   */
  setupUsercentricsEventHandlers: () => void;

  /**
   * Initializes Google Maps for location search hits if relevant cookies are
   * accepted and the location has coordinates specified.
   */
  initialize: () => void;
};

const LocationHitMaps: LocationHitMapsApi = {
  setupUsercentricsEventHandlers: () => {
    Usercentrics.addEventListener("initialized", LocationHitMaps.initialize);
    Usercentrics.addEventListener("updated", LocationHitMaps.initialize);
  },

  initialize: async () => {
    const mapWrappers = document.querySelectorAll("[data-js-location-hit-map-wrapper]");

    if (!mapWrappers?.length) {
      return;
    }

    // Ensure cookie consent.

    if (!Usercentrics.getDataProcessingConsent("Google Maps")) {
      const resultList = document.querySelector("[data-map-consent-err]") as HTMLElement;
      const consentError = resultList.dataset.mapConsentErr;

      for (const wrapper of mapWrappers) {
        const mapWrapper = wrapper as HTMLElement;
        mapWrapper.classList.remove("rounded-sm");
        mapWrapper.innerHTML = `<div class="border border-black p-20 bg-tint-orange">${consentError}</div>`;
      }

      return;
    }

    // Set up maps for location hits.

    const { Map } = (await google.maps.importLibrary("maps")) as google.maps.MapsLibrary;
    const { AdvancedMarkerElement } = (await google.maps.importLibrary(
      "marker"
    )) as google.maps.MarkerLibrary;

    for (const wrapper of mapWrappers) {
      const mapWrapper = wrapper as HTMLElement;

      const location = JSON.parse(
        mapWrapper.dataset.location || "{}"
      ) as google.maps.LatLng;

      if (location.lat === undefined || location.lng === undefined) {
        // No location, so we won't show a map for this search hit.
        mapWrapper.classList.add("hidden");
        continue;
      }

      mapWrapper.classList.add("rounded-sm");

      // The map, centered at location
      map = new Map(mapWrapper, {
        mapId: "location",
        zoom: 10,
        center: location,
        maxZoom: 15,

        // Prevent displaying (gray) areas outside of the map
        restriction: {
          latLngBounds: { north: 85, south: -85, west: -180, east: 180 },
        },
      });

      // Place marker

      const pinImage = document.createElement("img");
      pinImage.src = "/dist/Features/Search/map-pin.svg";

      new AdvancedMarkerElement({
        position: location,
        map: map,
        content: pinImage,
      });
    }
  },
};

export default LocationHitMaps;
